export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "exam_tab_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exams"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select an exam to view inventory"])},
        "view_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam inventory report"])},
        "exam_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam inventory"])},
        "version_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam Ver#"])},
        "inter_provincial": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontario / Interprovincial"])},
        "available_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Available inventory"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Exam status"])},
        "trade_associations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trade associations"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["There are no items to display"])}
      },
      "fr": {
        "exam_tab_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Examens"])},
        "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélectionner un examen pour voir le répertoire"])},
        "view_report": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rapport d'inventaire des examens"])},
        "exam_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Répertoire d’examens"])},
        "version_text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Numéro de version de l’examen#"])},
        "inter_provincial": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontario / Interprovincial"])},
        "available_inventory": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Répertoire disponible"])},
        "status": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Statut de l'examen"])},
        "trade_associations": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Associations professionnelles"])},
        "no_data": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Votre recherche a renvoyé 0 résultats."])}
      }
    }
  })
}